import service from '@/util/require';

export function getFeedbackPage(params) {
  return service({
    url: '/feedback/page',
    method: 'post',
    data: params
  });
}

export function deleteFeedback(id) {
  return service({
    url: `/feedback/delete`,
    method: 'delete',
    params: { id }
  });
}

export function handleFeedback(data) {
  return service({
    url: '/feedback/handle',
    method: 'post',
    data
  });
}

export function getUnreadCount() {
  return service({
    url: '/feedback/selctUnReadCount',
    method: 'get'
  });
}
